<nav class="navbar navbar-expand-md navbar-dark">
    <div class="container-fluid">
        <a class="navbar-brand" routerLink="/dashboard"><img width="100px" src="assets/metal-logo.png"
                alt="Metal Supermarkets Logo" class="topbar-logo" /></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav mr-auto nav-fill">
                <li ngbDropdown class="nav-item" routerLinkActive="active">
                    <a class="nav-link"
                        [routerLink]="['/orders']">Orders</a>
                </li>
                <li ngbDropdown class="nav-item" routerLinkActive="active">
                    <a class="nav-link"
                        [routerLink]="['/products']">Products</a>
                </li>
                <li ngbDropdown class="nav-item" routerLinkActive="active">
                    <a class="nav-link"
                        [routerLink]="['/stores','postal-codes-delivery']">Delivery Rates</a>
                </li>
                <li ngbDropdown class="nav-item" routerLinkActive="active">
                    <a class="nav-link"
                        [routerLink]="['/reports','mso-report']">MSO Report</a>
                </li>
                <li ngbDropdown class="nav-item" routerLinkActive="active">
                    <a class="nav-link"
                        [routerLink]="['/stores','store-protected-area']">Store Protected Area</a>
                </li>
            </ul>
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link">{{data?.userName}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" style="cursor:pointer;" (click)="logout()">Logout</a>
                </li>
            </ul>
        </div>
    </div>
</nav>